export enum AxisTypes {
  NumericAxis = 0,
  LabeledAxis = 1 ,
  DateAxis = 2,
  None = 3
}
